import { Chain } from '../types/payment.types';

interface ToggleState {
    selectedChains: string[];
    selectedTokens: string[];
}

export function toggleChainSelection<T extends ToggleState>(
    prev: T,
    chainId: string,
    chains: Chain[] | undefined
): T {
    const chain = chains?.find(c => c.id.toString() === chainId);
    const chainTokens = chain?.tokens.map(t => `${chainId}:${t.symbol}`) || [];
    const isSelected = prev.selectedChains.includes(chainId);

    let newChains = prev.selectedChains;
    let newTokens = prev.selectedTokens;

    if (isSelected) {
        newChains = newChains.filter(id => id !== chainId);
        newTokens = newTokens.filter(t => !chainTokens.includes(t));
    } else {
        newChains = [...newChains, chainId];
        const tokensToAdd = chainTokens.filter(t => !newTokens.includes(t));
        newTokens = [...newTokens, ...tokensToAdd];
    }

    return { ...prev, selectedChains: newChains, selectedTokens: newTokens };
}

export function toggleTokenSelection<T extends ToggleState>(
    prev: T,
    chainId: string,
    tokenSymbol: string
): T {
    const tokenKey = `${chainId}:${tokenSymbol}`;
    const isSelected = prev.selectedTokens.includes(tokenKey);

    let newTokens = isSelected
        ? prev.selectedTokens.filter(t => t !== tokenKey)
        : [...prev.selectedTokens, tokenKey];

    let newChains = prev.selectedChains;
    if (!isSelected && !newChains.includes(chainId)) {
        newChains = [...newChains, chainId];
    }

    return { ...prev, selectedTokens: newTokens, selectedChains: newChains };
}
